import React from 'react';
import { Link } from 'react-router-dom';
import './FooterSection.css';

const FooterSection = () => {
    return (
        <section className="footer-section-container">
            <div className="footer-content-wrapper">
                <div className="footer-text-container">
                    <h2 className="footer-heading">
                        Looking to integrate advanced AI into your research? <br />
                        Let’s explore what’s possible together.<br />
                        <span className="footer-highlight">Connect with us!</span>
                    </h2>
                </div>

                <Link to="/contact" className="footer-email-btn" style={{ textDecoration: 'none' }}>
                    Email us
                </Link>
            </div>
        </section>
    );
};

export default FooterSection;
